import { render, staticRenderFns } from "./ColorPciker.vue?vue&type=template&id=520e08bf"
import script from "./ColorPciker.vue?vue&type=script&lang=ts"
export * from "./ColorPciker.vue?vue&type=script&lang=ts"
import style0 from "./ColorPciker.vue?vue&type=style&index=0&id=520e08bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports